<template>
  <v-dialog
    :value="value"
    :max-width="400"
    persistent
    :attach="attach"
    content-class="iq-suggest-exit-confirm-dialog"
    @keydown.esc="handleKeepReviewing"
  >
    <div
      class="iq-suggest-exit-confirm__card"
      data-testid="iq-exit-confirm"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="iq-suggest-exit-title"
    >
      <div class="iq-suggest-exit-confirm__header">
        <div class="iq-suggest-exit-confirm__icon-wrap" aria-hidden="true">
          <v-icon size="24" color="#667085">mdi-help-circle-outline</v-icon>
        </div>
        <button
          type="button"
          class="iq-suggest-exit-confirm__close-btn"
          aria-label="Close exit confirmation"
          @click="handleKeepReviewing"
        >
          <v-icon small>mdi-close</v-icon>
        </button>
      </div>

      <p id="iq-suggest-exit-title" class="iq-suggest-exit-confirm__title">
        Exit before finishing?
      </p>
      <p class="iq-suggest-exit-confirm__body">
        {{ suggestionsRemaining }} suggestion{{ suggestionsRemaining === 1 ? "" : "s" }} left —
        closing discards them and this conversation. Anything already created stays attached.
      </p>

      <div class="iq-suggest-exit-confirm__actions">
        <StandardButton
          size="full-width"
          type="magenta"
          variant="outline"
          label="Keep reviewing"
          @click="handleKeepReviewing"
        />
        <StandardButton
          size="full-width"
          type="red"
          variant="primary"
          label="Exit"
          @click="handleConfirmExit"
        />
      </div>
    </div>
  </v-dialog>
</template>

<script setup>
import StandardButton from "@components/StandardButton/StandardButton.vue";

defineProps({
  value: { type: Boolean, default: false },
  suggestionsRemaining: { type: Number, default: 0 },
  attach: { type: String, default: undefined },
});

const emit = defineEmits(["input", "keep-reviewing", "confirm-exit"]);

function handleKeepReviewing() {
  emit("keep-reviewing");
  emit("input", false);
}

function handleConfirmExit() {
  emit("confirm-exit");
  emit("input", false);
}
</script>

<style scoped>
.iq-suggest-exit-confirm__card {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow:
    0 20px 24px -4px rgba(16, 24, 40, 0.08),
    0 8px 8px -4px rgba(16, 24, 40, 0.03);
  min-width: 400px;
}

.iq-suggest-exit-confirm__card::before {
  content: "";
  position: absolute;
  top: -80px;
  left: 50%;
  transform: translateX(-50%);
  width: 336px;
  height: 336px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(152, 162, 179, 0.12) 0%, rgba(152, 162, 179, 0) 70%);
  pointer-events: none;
}

.iq-suggest-exit-confirm__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
}

.iq-suggest-exit-confirm__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 1px 1px rgba(16, 24, 40, 0.05);
}

.iq-suggest-exit-confirm__close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: #98a2b3;
}

.iq-suggest-exit-confirm__title {
  position: relative;
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #101828;
  text-align: center;
}

.iq-suggest-exit-confirm__body {
  position: relative;
  margin: 0 auto 32px;
  max-width: 284px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #475467;
  text-align: center;
}

.iq-suggest-exit-confirm__actions {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
</style>

<style>
.iq-suggest-exit-confirm-dialog {
  z-index: 10050 !important;
}
</style>
